class FooterLang extends HTMLElement {
  connectedCallback() {
    this._moves = 0;
    this._resetTimer();
    this._grab();

    this.observer = new MutationObserver(() => this._grab());
    this.observer.observe(document.body, { childList: true, subtree: true });
  }

  disconnectedCallback() {
    this._stop();
  }

  _grab() {
    const switcher = document.querySelector(".weglot-container");

    if (!switcher || switcher.parentElement === this) return;

    this.appendChild(switcher);

    if (++this._moves > 30) {
      this._stop();
    } else {
      this._resetTimer();
    }
  }

  _resetTimer() {
    clearTimeout(this._timer);
    this._timer = setTimeout(() => this._stop(), 20000);
  }

  _stop() {
    clearTimeout(this._timer);
    this.observer?.disconnect();
    this.observer = null;
  }
}

if (!customElements.get("footer-lang")) {
  customElements.define("footer-lang", FooterLang);
}
